import { render } from "./Main.vue?vue&type=template&id=6854c0fd&lang=pug"
const script = {}

import exportComponent from "/Users/QwanteanPh/Works/Projects/ITD212WF1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__